
import Vue from 'vue'
import tmp from './tmp'

// 由于目前vue2.7不支持导出render方法，所以参考elementUI的做法
// https://github.com/ElemeFE/element/blob/dev/packages/message-box/src/main.js

const Constructor = Vue.extend(tmp)
let instance

const initInstance = () => {
  if (instance) return
  instance = new Constructor({
    el: document.createElement('div')
  })
}

const main = function (message, title, props) {
  initInstance()
  
  return new Promise((resolve, reject) => {
    props = {
      ...props,
      message,
      title,
      resolve,
      reject
    }

    for (let prop in props) {
      if (props.hasOwnProperty(prop)) {
        instance[prop] = props[prop]
      }
    }

    instance._setupProxy.visible = true // vue2.7特殊处理
    document.body.appendChild(instance.$el)
  })
}

;['confirm', 'alert'].forEach(key => {
  main[key] = (message, title, options) => {
    return main(message, title, {...options, $type: key})
  }
})

export default main
